"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShutterstockTosLinks;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _ShutterstockMaintenanceAlert = _interopRequireDefault(require("FileManagerCore/components/ShutterstockMaintenanceAlert"));

function i18nKey(suffix) {
  return "FileManagerLib.panels.tabs.shutterstock." + suffix;
}

function ShutterstockTosLinks(props) {
  var use = props.use;
  return _react.default.createElement(_UISection.default, null, _react.default.createElement(_Small.default, null, _react.default.createElement(_ShutterstockMaintenanceAlert.default, {
    useShortVersion: true,
    className: "m-bottom-2"
  }), _react.default.createElement(_FormattedReactMessage.default, {
    message: i18nKey('headerTerms'),
    options: {
      websiteTermsLink: _react.default.createElement(_UILink.default, {
        use: use,
        href: "https://www.shutterstock.com/terms",
        external: true
      }, _I18n.default.text(i18nKey('websiteTermsAndPolicy'))),
      licensingTermsLink: _react.default.createElement(_UILink.default, {
        use: use,
        href: "https://www.shutterstock.com/license",
        external: true
      }, _I18n.default.text(i18nKey('licensingTerms')))
    }
  })));
}

ShutterstockTosLinks.propTypes = {
  use: _UILink.default.propTypes.use
};
ShutterstockTosLinks.defaultProps = {
  use: 'light'
};
module.exports = exports.default;